@if (store.isSearching()) {
  <ul
    class="search-results"
    aria-hidden="true">
    @for (row of skeletonRows; track row) {
      <li class="search-results__option search-results__skeleton">
        <span class="search-results__icon"></span>
        <span class="search-results__skeleton-text"></span>
      </li>
    }
  </ul>
}

@if (store.noResults()) {
  <div class="search-results__empty">
    <sharry-icon
      name="magnifying-glass"
      svgClass="search-results__empty-icon"></sharry-icon>
    <p>{{ 'search-results.no-results' | i18next: { value: store.term() } }}</p>
  </div>
}

<ul
  class="search-results"
  role="listbox"
  [id]="listboxId()"
  [attr.aria-label]="'explore.bottom-bar.search' | i18next"
  [attr.aria-busy]="store.loading()">
  @for (option of store.navigableOptions(); track option.kind + option.id; let i = $index) {
    <li
      role="none"
      [class.search-results__divider]="option.kind === 'all'">
      <a
        class="search-results__option"
        role="option"
        [class.search-results__option--active]="store.activeIndex() === i"
        [class.search-results__option--all]="option.kind === 'all'"
        [id]="optionId(listboxId(), i)"
        [attr.aria-selected]="store.activeIndex() === i"
        [routerLink]="option.link"
        [queryParams]="option.queryParams"
        [replaceUrl]="store.hasHistoryEntry()"
        (click)="store.onNavigate(option)">
        @if (option.avatar) {
          <span
            aria-hidden="true"
            [avatar]="{ user: option.avatar, size: 'small', imgSize: '40px' }"></span>
        } @else if (option.kind === 'content') {
          <img
            class="search-results__thumb"
            alt=""
            width="40"
            height="40"
            decoding="async"
            [src]="option.image || placeholder" />
        } @else {
          <span
            class="search-results__icon"
            aria-hidden="true">
            <sharry-icon
              svgClass="svg-icon"
              [name]="icons[option.kind]"></sharry-icon>
          </span>
        }
        <span class="search-results__label">
          @if (option.kind === 'all') {
            {{ 'search-bar.show-all' | i18next: { value: store.term() } }}
          } @else {
            {{ option.label }}
          }
        </span>
      </a>
    </li>
  }
</ul>

<p
  class="cdk-visually-hidden"
  aria-live="polite">
  @if (store.hasTerm() && store.isSettled()) {
    {{ 'search-bar.results-count' | i18next: { count: store.options().length } }}
  }
</p>
